import $ from "jquery";

// 행정동 불러오기
export const geoje = [
    {name: "일운면", idx: 3656},
    {name: "동부면", idx: 3657},
    {name: "남부면", idx: 3658},
    {name: "거제면", idx: 3659},
    {name: "둔덕면", idx: 3660},
    {name: "사등면", idx: 3661},
    {name: "연초면", idx: 3663},
    {name: "하청면", idx: 3664},
    {name: "장목면", idx: 3666},
    {name: "장승포동", idx: 3668},
    {name: "능포동", idx: 3669},
    {name: "아주동", idx: 3670},
    {name: "옥포1동", idx: 3671},
    {name: "옥포2동", idx: 3672},
    {name: "장평동", idx: 3673},
    {name: "고현동", idx: 3674},
    {name: "상문동", idx: 3675},
    {name: "수양동", idx: 3676}
]

export const busan = [
    {name: "미선택", idx: 0},
    {name: "중구", idx: 1},
    {name: "서구", idx: 2},
    {name: "동구", idx: 3},
    {name: "영도구", idx: 4},
    {name: "부산진구", idx: 5},
    {name: "동래구", idx: 6},
    {name: "남구", idx: 7},
    {name: "북구", idx: 8},
    {name: "해운대구", idx: 9},
    {name: "사하구", idx: 10},
    {name: "금정구", idx: 11},
    {name: "강서구", idx: 12},
    {name: "연제구", idx: 13},
    {name: "수영구", idx: 14},
    {name: "사상구", idx: 15},
    {name: "기장군", idx: 16},
]

export function busanDong(type) {
    let busan1 = [
        {name: "중앙동", idx: 455},
        {name: "동광동", idx: 456},
        {name: "대청동", idx: 457},
        {name: "보수동", idx: 458},
        {name: "부평동", idx: 459},
        {name: "광복동", idx: 460},
        {name: "남포동", idx: 461},
        {name: "영주1동", idx: 462},
        {name: "영주2동", idx: 463}
    ]
    let busan2 = [
        {name: "동대신1동", idx: 465},
        {name: "동대신2동", idx: 466},
        {name: "동대신3동", idx: 467},
        {name: "서대신1동", idx: 468},
        {name: "서대신3동", idx: 469},
        {name: "서대신4동", idx: 470},
        {name: "부민동", idx: 471},
        {name: "아미동", idx: 472},
        {name: "초장동", idx: 473},
        {name: "충무동", idx: 474},
        {name: "남부민1동", idx: 475},
        {name: "남부민2동", idx: 476},
        {name: "암남동", idx: 477}
    ]
    let busan3 = [
        {name: "초량1동", idx: 479},
        {name: "초량2동", idx: 480},
        {name: "초량3동", idx: 481},
        {name: "초량6동", idx: 482},
        {name: "수정1동", idx: 483},
        {name: "수정2동", idx: 484},
        {name: "수정4동", idx: 485},
        {name: "수정5동", idx: 486},
        {name: "좌천동", idx: 487},
        {name: "범일1동", idx: 488},
        {name: "범일2동", idx: 489},
        {name: "범일5동", idx: 490}
    ]
    let busan4 = [
        {name: "남항동", idx: 492},
        {name: "영선1동", idx: 493},
        {name: "영선2동", idx: 494},
        {name: "신선동", idx: 495},
        {name: "봉래1동", idx: 496},
        {name: "봉래2동", idx: 497},
        {name: "청학1동", idx: 498},
        {name: "청학2동", idx: 499},
        {name: "동삼1동", idx: 500},
        {name: "동삼2동", idx: 501},
        {name: "동삼3동", idx: 502}
    ]
    let busan5 = [
        {name: "부전1동", idx: 504},
        {name: "부전2동", idx: 505},
        {name: "연지동", idx: 506},
        {name: "초읍동", idx: 507},
        {name: "양정1동", idx: 508},
        {name: "양정2동", idx: 509},
        {name: "전포1동", idx: 510},
        {name: "전포2동", idx: 511},
        {name: "부암1동", idx: 512},
        {name: "부암3동", idx: 513},
        {name: "당감1동", idx: 514},
        {name: "당감2동", idx: 515},
        {name: "당감4동", idx: 516},
        {name: "가야1동", idx: 517},
        {name: "가야2동", idx: 518},
        {name: "개금1동", idx: 519},
        {name: "개금2동", idx: 520},
        {name: "개금3동", idx: 521},
        {name: "범천1동", idx: 522},
        {name: "범천2동", idx: 523}
    ]
    let busan6 = [
        {name: "수민동", idx: 525},
        {name: "복산동", idx: 526},
        {name: "명륜동", idx: 527},
        {name: "온천1동", idx: 528},
        {name: "온천2동", idx: 529},
        {name: "온천3동", idx: 530},
        {name: "사직1동", idx: 531},
        {name: "사직2동", idx: 532},
        {name: "사직3동", idx: 533},
        {name: "안락1동", idx: 534},
        {name: "안락2동", idx: 535},
        {name: "명장1동", idx: 536},
        {name: "명장2동", idx: 537}
    ]
    let busan7 = [
        {name: "대연1동", idx: 539},
        {name: "대연3동", idx: 540},
        {name: "대연4동", idx: 541},
        {name: "대연5동", idx: 542},
        {name: "대연6동", idx: 543},
        {name: "용호1동", idx: 544},
        {name: "용호2동", idx: 545},
        {name: "용호3동", idx: 546},
        {name: "용호4동", idx: 547},
        {name: "용당동", idx: 548},
        {name: "감만1동", idx: 549},
        {name: "감만2동", idx: 550},
        {name: "우암동", idx: 551},
        {name: "문현1동", idx: 552},
        {name: "문현2동", idx: 553},
        {name: "문현3동", idx: 554},
        {name: "문현4동", idx: 555}
    ]
    let busan8 = [
        {name: "구포1동", idx: 557},
        {name: "구포2동", idx: 558},
        {name: "구포3동", idx: 559},
        {name: "금곡동", idx: 560},
        {name: "화명1동", idx: 561},
        {name: "화명2동", idx: 562},
        {name: "화명3동", idx: 563},
        {name: "덕천1동", idx: 564},
        {name: "덕천2동", idx: 565},
        {name: "덕천3동", idx: 566},
        {name: "만덕1동", idx: 567},
        {name: "만덕2동", idx: 568},
        {name: "만덕3동", idx: 569}
    ]
    let busan9 = [
        {name: "우1동", idx: 571},
        {name: "우2동", idx: 572},
        {name: "우3동", idx: 573},
        {name: "중1동", idx: 574},
        {name: "중2동", idx: 575},
        {name: "좌1동", idx: 576},
        {name: "좌2동", idx: 577},
        {name: "좌3동", idx: 578},
        {name: "좌4동", idx: 579},
        {name: "송정동", idx: 580},
        {name: "반여1동", idx: 581},
        {name: "반여2동", idx: 582},
        {name: "반여3동", idx: 583},
        {name: "반여4동", idx: 584},
        {name: "반송1동", idx: 585},
        {name: "반송2동", idx: 586},
        {name: "재송1동", idx: 587},
        {name: "재송2동", idx: 588}
    ]
    let busan10 = [
        {name: "괴정1동", idx: 590},
        {name: "괴정2동", idx: 591},
        {name: "괴정3동", idx: 592},
        {name: "괴정4동", idx: 593},
        {name: "당리동", idx: 594},
        {name: "하단1동", idx: 595},
        {name: "하단2동", idx: 596},
        {name: "신평1동", idx: 597},
        {name: "신평2동", idx: 598},
        {name: "장림1동", idx: 599},
        {name: "장림2동", idx: 600},
        {name: "다대1동", idx: 601},
        {name: "다대2동", idx: 602},
        {name: "구평동", idx: 603},
        {name: "감천1동", idx: 604},
        {name: "감천2동", idx: 605}
    ]
    let busan11 = [
        {name: "서1동", idx: 607},
        {name: "서2동", idx: 608},
        {name: "서3동", idx: 609},
        {name: "금사회동동", idx: 610},
        {name: "부곡1동", idx: 611},
        {name: "부곡2동", idx: 612},
        {name: "부곡3동", idx: 613},
        {name: "부곡4동", idx: 614},
        {name: "장전1동", idx: 615},
        {name: "장전2동", idx: 616},
        {name: "선두구동", idx: 617},
        {name: "청룡노포동", idx: 618},
        {name: "남산동", idx: 619},
        {name: "구서1동", idx: 620},
        {name: "구서2동", idx: 621},
        {name: "금성동", idx: 622}
    ]
    let busan12 = [
        {name: "대저1동", idx: 624},
        {name: "대저2동", idx: 625},
        {name: "강동동", idx: 626},
        {name: "명지1동", idx: 627},
        {name: "명지2동", idx: 628},
        {name: "가락동", idx: 629},
        {name: "녹산동", idx: 630},
        {name: "가덕도동", idx: 631}
    ]
    let busan13 = [
        {name: "거제1동", idx: 633},
        {name: "거제2동", idx: 634},
        {name: "거제3동", idx: 635},
        {name: "거제4동", idx: 636},
        {name: "연산1동", idx: 637},
        {name: "연산2동", idx: 638},
        {name: "연산3동", idx: 639},
        {name: "연산4동", idx: 640},
        {name: "연산5동", idx: 641},
        {name: "연산6동", idx: 642},
        {name: "연산8동", idx: 643},
        {name: "연산9동", idx: 644}
    ]
    let busan14 = [
        {name: "남천1동", idx: 646},
        {name: "남천2동", idx: 647},
        {name: "수영동", idx: 648},
        {name: "망미1동", idx: 649},
        {name: "망미2동", idx: 650},
        {name: "광안1동", idx: 651},
        {name: "광안2동", idx: 652},
        {name: "광안3동", idx: 653},
        {name: "광안4동", idx: 654},
        {name: "민락동", idx: 655}
    ]
    let busan15 = [
        {name: "삼락동", idx: 657},
        {name: "모라1동", idx: 658},
        {name: "모라3동", idx: 659},
        {name: "덕포1동", idx: 660},
        {name: "덕포2동", idx: 661},
        {name: "괘법동", idx: 662},
        {name: "감전동", idx: 663},
        {name: "주례1동", idx: 664},
        {name: "주례2동", idx: 665},
        {name: "주례3동", idx: 666},
        {name: "학장동", idx: 667},
        {name: "엄궁동", idx: 668}
    ]
    let busan16 = [
        {name: "기장읍", idx: 670},
        {name: "장안읍", idx: 671},
        {name: "정관읍", idx: 672},
        {name: "일광읍", idx: 673},
        {name: "철마면", idx: 674}
    ]

    let dong

    switch (Number(type)) {
        case 1:
            dong = busan1
            break;
        case 2:
            dong = busan2
            break;
        case 3:
            dong = busan3
            break;
        case 4:
            dong = busan4
            break;
        case 5:
            dong = busan5
            break;
        case 6:
            dong = busan6
            break;
        case 7:
            dong = busan7
            break;
        case 8:
            dong = busan8
            break;
        case 9:
            dong = busan9
            break;
        case 10:
            dong = busan10
            break;
        case 11:
            dong = busan11
            break;
        case 12:
            dong = busan12
            break;
        case 13:
            dong = busan13
            break;
        case 14:
            dong = busan14
            break;
        case 15:
            dong = busan15
            break;
        case 16:
            dong = busan16
            break;
        default:
            dong = 0
            break;
    }

    return dong
}

const dong = [
    {name: "부산광역시 중구 중앙동", idx: 455},
    {name: "부산광역시 중구 동광동", idx: 456},
    {name: "부산광역시 중구 대청동", idx: 457},
    {name: "부산광역시 중구 보수동", idx: 458},
    {name: "부산광역시 중구 부평동", idx: 459},
    {name: "부산광역시 중구 광복동", idx: 460},
    {name: "부산광역시 중구 남포동", idx: 461},
    {name: "부산광역시 중구 영주1동", idx: 462},
    {name: "부산광역시 중구 영주2동", idx: 463},
    {name: "부산광역시 서구 동대신1동", idx: 465},
    {name: "부산광역시 서구 동대신2동", idx: 466},
    {name: "부산광역시 서구 동대신3동", idx: 467},
    {name: "부산광역시 서구 서대신1동", idx: 468},
    {name: "부산광역시 서구 서대신3동", idx: 469},
    {name: "부산광역시 서구 서대신4동", idx: 470},
    {name: "부산광역시 서구 부민동", idx: 471},
    {name: "부산광역시 서구 아미동", idx: 472},
    {name: "부산광역시 서구 초장동", idx: 473},
    {name: "부산광역시 서구 충무동", idx: 474},
    {name: "부산광역시 서구 남부민1동", idx: 475},
    {name: "부산광역시 서구 남부민2동", idx: 476},
    {name: "부산광역시 서구 암남동", idx: 477},
    {name: "부산광역시 동구 초량1동", idx: 479},
    {name: "부산광역시 동구 초량2동", idx: 480},
    {name: "부산광역시 동구 초량3동", idx: 481},
    {name: "부산광역시 동구 초량6동", idx: 482},
    {name: "부산광역시 동구 수정1동", idx: 483},
    {name: "부산광역시 동구 수정2동", idx: 484},
    {name: "부산광역시 동구 수정4동", idx: 485},
    {name: "부산광역시 동구 수정5동", idx: 486},
    {name: "부산광역시 동구 좌천동", idx: 487},
    {name: "부산광역시 동구 범일1동", idx: 488},
    {name: "부산광역시 동구 범일2동", idx: 489},
    {name: "부산광역시 동구 범일5동", idx: 490},
    {name: "부산광역시 영도구 남항동", idx: 492},
    {name: "부산광역시 영도구 영선1동", idx: 493},
    {name: "부산광역시 영도구 영선2동", idx: 494},
    {name: "부산광역시 영도구 신선동", idx: 495},
    {name: "부산광역시 영도구 봉래1동", idx: 496},
    {name: "부산광역시 영도구 봉래2동", idx: 497},
    {name: "부산광역시 영도구 청학1동", idx: 498},
    {name: "부산광역시 영도구 청학2동", idx: 499},
    {name: "부산광역시 영도구 동삼1동", idx: 500},
    {name: "부산광역시 영도구 동삼2동", idx: 501},
    {name: "부산광역시 영도구 동삼3동", idx: 502},
    {name: "부산광역시 부산진구 부전1동", idx: 504},
    {name: "부산광역시 부산진구 부전2동", idx: 505},
    {name: "부산광역시 부산진구 연지동", idx: 506},
    {name: "부산광역시 부산진구 초읍동", idx: 507},
    {name: "부산광역시 부산진구 양정1동", idx: 508},
    {name: "부산광역시 부산진구 양정2동", idx: 509},
    {name: "부산광역시 부산진구 전포1동", idx: 510},
    {name: "부산광역시 부산진구 전포2동", idx: 511},
    {name: "부산광역시 부산진구 부암1동", idx: 512},
    {name: "부산광역시 부산진구 부암3동", idx: 513},
    {name: "부산광역시 부산진구 당감1동", idx: 514},
    {name: "부산광역시 부산진구 당감2동", idx: 515},
    {name: "부산광역시 부산진구 당감4동", idx: 516},
    {name: "부산광역시 부산진구 가야1동", idx: 517},
    {name: "부산광역시 부산진구 가야2동", idx: 518},
    {name: "부산광역시 부산진구 개금1동", idx: 519},
    {name: "부산광역시 부산진구 개금2동", idx: 520},
    {name: "부산광역시 부산진구 개금3동", idx: 521},
    {name: "부산광역시 부산진구 범천1동", idx: 522},
    {name: "부산광역시 부산진구 범천2동", idx: 523},
    {name: "부산광역시 동래구 수민동", idx: 525},
    {name: "부산광역시 동래구 복산동", idx: 526},
    {name: "부산광역시 동래구 명륜동", idx: 527},
    {name: "부산광역시 동래구 온천1동", idx: 528},
    {name: "부산광역시 동래구 온천2동", idx: 529},
    {name: "부산광역시 동래구 온천3동", idx: 530},
    {name: "부산광역시 동래구 사직1동", idx: 531},
    {name: "부산광역시 동래구 사직2동", idx: 532},
    {name: "부산광역시 동래구 사직3동", idx: 533},
    {name: "부산광역시 동래구 안락1동", idx: 534},
    {name: "부산광역시 동래구 안락2동", idx: 535},
    {name: "부산광역시 동래구 명장1동", idx: 536},
    {name: "부산광역시 동래구 명장2동", idx: 537},
    {name: "부산광역시 남구 대연1동", idx: 539},
    {name: "부산광역시 남구 대연3동", idx: 540},
    {name: "부산광역시 남구 대연4동", idx: 541},
    {name: "부산광역시 남구 대연5동", idx: 542},
    {name: "부산광역시 남구 대연6동", idx: 543},
    {name: "부산광역시 남구 용호1동", idx: 544},
    {name: "부산광역시 남구 용호2동", idx: 545},
    {name: "부산광역시 남구 용호3동", idx: 546},
    {name: "부산광역시 남구 용호4동", idx: 547},
    {name: "부산광역시 남구 용당동", idx: 548},
    {name: "부산광역시 남구 감만1동", idx: 549},
    {name: "부산광역시 남구 감만2동", idx: 550},
    {name: "부산광역시 남구 우암동", idx: 551},
    {name: "부산광역시 남구 문현1동", idx: 552},
    {name: "부산광역시 남구 문현2동", idx: 553},
    {name: "부산광역시 남구 문현3동", idx: 554},
    {name: "부산광역시 남구 문현4동", idx: 555},
    {name: "부산광역시 북구 구포1동", idx: 557},
    {name: "부산광역시 북구 구포2동", idx: 558},
    {name: "부산광역시 북구 구포3동", idx: 559},
    {name: "부산광역시 북구 금곡동", idx: 560},
    {name: "부산광역시 북구 화명1동", idx: 561},
    {name: "부산광역시 북구 화명2동", idx: 562},
    {name: "부산광역시 북구 화명3동", idx: 563},
    {name: "부산광역시 북구 덕천1동", idx: 564},
    {name: "부산광역시 북구 덕천2동", idx: 565},
    {name: "부산광역시 북구 덕천3동", idx: 566},
    {name: "부산광역시 북구 만덕1동", idx: 567},
    {name: "부산광역시 북구 만덕2동", idx: 568},
    {name: "부산광역시 북구 만덕3동", idx: 569},
    {name: "부산광역시 해운대구 우1동", idx: 571},
    {name: "부산광역시 해운대구 우2동", idx: 572},
    {name: "부산광역시 해운대구 우3동", idx: 573},
    {name: "부산광역시 해운대구 중1동", idx: 574},
    {name: "부산광역시 해운대구 중2동", idx: 575},
    {name: "부산광역시 해운대구 좌1동", idx: 576},
    {name: "부산광역시 해운대구 좌2동", idx: 577},
    {name: "부산광역시 해운대구 좌3동", idx: 578},
    {name: "부산광역시 해운대구 좌4동", idx: 579},
    {name: "부산광역시 해운대구 송정동", idx: 580},
    {name: "부산광역시 해운대구 반여1동", idx: 581},
    {name: "부산광역시 해운대구 반여2동", idx: 582},
    {name: "부산광역시 해운대구 반여3동", idx: 583},
    {name: "부산광역시 해운대구 반여4동", idx: 584},
    {name: "부산광역시 해운대구 반송1동", idx: 585},
    {name: "부산광역시 해운대구 반송2동", idx: 586},
    {name: "부산광역시 해운대구 재송1동", idx: 587},
    {name: "부산광역시 해운대구 재송2동", idx: 588},
    {name: "부산광역시 사하구 괴정1동", idx: 590},
    {name: "부산광역시 사하구 괴정2동", idx: 591},
    {name: "부산광역시 사하구 괴정3동", idx: 592},
    {name: "부산광역시 사하구 괴정4동", idx: 593},
    {name: "부산광역시 사하구 당리동", idx: 594},
    {name: "부산광역시 사하구 하단1동", idx: 595},
    {name: "부산광역시 사하구 하단2동", idx: 596},
    {name: "부산광역시 사하구 신평1동", idx: 597},
    {name: "부산광역시 사하구 신평2동", idx: 598},
    {name: "부산광역시 사하구 장림1동", idx: 599},
    {name: "부산광역시 사하구 장림2동", idx: 600},
    {name: "부산광역시 사하구 다대1동", idx: 601},
    {name: "부산광역시 사하구 다대2동", idx: 602},
    {name: "부산광역시 사하구 구평동", idx: 603},
    {name: "부산광역시 사하구 감천1동", idx: 604},
    {name: "부산광역시 사하구 감천2동", idx: 605},
    {name: "부산광역시 금정구 서1동", idx: 607},
    {name: "부산광역시 금정구 서2동", idx: 608},
    {name: "부산광역시 금정구 서3동", idx: 609},
    {name: "부산광역시 금정구 금사회동동", idx: 610},
    {name: "부산광역시 금정구 부곡1동", idx: 611},
    {name: "부산광역시 금정구 부곡2동", idx: 612},
    {name: "부산광역시 금정구 부곡3동", idx: 613},
    {name: "부산광역시 금정구 부곡4동", idx: 614},
    {name: "부산광역시 금정구 장전1동", idx: 615},
    {name: "부산광역시 금정구 장전2동", idx: 616},
    {name: "부산광역시 금정구 선두구동", idx: 617},
    {name: "부산광역시 금정구 청룡노포동", idx: 618},
    {name: "부산광역시 금정구 남산동", idx: 619},
    {name: "부산광역시 금정구 구서1동", idx: 620},
    {name: "부산광역시 금정구 구서2동", idx: 621},
    {name: "부산광역시 금정구 금성동", idx: 622},
    {name: "부산광역시 강서구 대저1동", idx: 624},
    {name: "부산광역시 강서구 대저2동", idx: 625},
    {name: "부산광역시 강서구 강동동", idx: 626},
    {name: "부산광역시 강서구 명지1동", idx: 627},
    {name: "부산광역시 강서구 명지2동", idx: 628},
    {name: "부산광역시 강서구 가락동", idx: 629},
    {name: "부산광역시 강서구 녹산동", idx: 630},
    {name: "부산광역시 강서구 가덕도동", idx: 631},
    {name: "부산광역시 연제구 거제1동", idx: 633},
    {name: "부산광역시 연제구 거제2동", idx: 634},
    {name: "부산광역시 연제구 거제3동", idx: 635},
    {name: "부산광역시 연제구 거제4동", idx: 636},
    {name: "부산광역시 연제구 연산1동", idx: 637},
    {name: "부산광역시 연제구 연산2동", idx: 638},
    {name: "부산광역시 연제구 연산3동", idx: 639},
    {name: "부산광역시 연제구 연산4동", idx: 640},
    {name: "부산광역시 연제구 연산5동", idx: 641},
    {name: "부산광역시 연제구 연산6동", idx: 642},
    {name: "부산광역시 연제구 연산8동", idx: 643},
    {name: "부산광역시 연제구 연산9동", idx: 644},
    {name: "부산광역시 수영구 남천1동", idx: 646},
    {name: "부산광역시 수영구 남천2동", idx: 647},
    {name: "부산광역시 수영구 수영동", idx: 648},
    {name: "부산광역시 수영구 망미1동", idx: 649},
    {name: "부산광역시 수영구 망미2동", idx: 650},
    {name: "부산광역시 수영구 광안1동", idx: 651},
    {name: "부산광역시 수영구 광안2동", idx: 652},
    {name: "부산광역시 수영구 광안3동", idx: 653},
    {name: "부산광역시 수영구 광안4동", idx: 654},
    {name: "부산광역시 수영구 민락동", idx: 655},
    {name: "부산광역시 사상구 삼락동", idx: 657},
    {name: "부산광역시 사상구 모라1동", idx: 658},
    {name: "부산광역시 사상구 모라3동", idx: 659},
    {name: "부산광역시 사상구 덕포1동", idx: 660},
    {name: "부산광역시 사상구 덕포2동", idx: 661},
    {name: "부산광역시 사상구 괘법동", idx: 662},
    {name: "부산광역시 사상구 감전동", idx: 663},
    {name: "부산광역시 사상구 주례1동", idx: 664},
    {name: "부산광역시 사상구 주례2동", idx: 665},
    {name: "부산광역시 사상구 주례3동", idx: 666},
    {name: "부산광역시 사상구 학장동", idx: 667},
    {name: "부산광역시 사상구 엄궁동", idx: 668},
    {name: "부산광역시 기장군 기장읍", idx: 670},
    {name: "부산광역시 기장군 장안읍", idx: 671},
    {name: "부산광역시 기장군 정관읍", idx: 672},
    {name: "부산광역시 기장군 일광읍", idx: 673},
    {name: "부산광역시 기장군 철마면", idx: 674}
]

export function dongName(idx) {
    let name = ''
    for(var i = 0; dong.length > i; i++) {
        if(Number(idx) === dong[i].idx) {
            name = dong[i].name
        }
    }

    return name
}

export function dongIdx(name) {
    let idx = ''
    for(var i = 0; dong.length > i; i++) {
        if(name === dong[i].name) {
            idx = dong[i].idx
        }
    }

    return idx
}

export function dongNameChange(dong) {
    let name = dong.split(" ");


    return name[name.length - 1];
}